module.exports = __webpack_public_path__ + "00ba76d97bb4c7d36a42ea56de8a1ad8.webp";